import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createSortaFriendsClickHandler } from '../utils/navigation';

const TermsOfService = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <div>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <h1 style={{ cursor: 'pointer' }} onClick={createSortaFriendsClickHandler(navigate)}>SortaFriends</h1>
            <button
              onClick={handleBack}
              className="btn"
              style={{ backgroundColor: 'var(--color-primary)', color: 'white', border: 'none' }}
            >
              Back
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="card">
          <h1>Terms of Service</h1>
          <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using SortaFriends ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>

          <h2>2. Age Requirement</h2>
          <p>You must be at least 18 years old to use this Service. By using the Service, you represent and warrant that you are 18 years of age or older.</p>
          <p>We do not knowingly collect information from anyone under 18. If we become aware that a person under 18 has created an account, we will delete it. If you believe we have collected information from someone under 18, please contact us immediately.</p>
          
          <h3>Adult-Oriented Content Notice</h3>
          <p>The Service may include adult-oriented themes, mature humor, and discussions intended for an adult audience. Explicit sexual content or pornography is prohibited, but frank, mature, or suggestive topics may appear. By using the Service, you acknowledge and accept exposure to such content consistent with our Community Rules.</p>

          <h2>3. Description of Service</h2>
          <p>SortaFriends is a social entertainment application that allows users to create and share rankings ("stacks") of various topics with friends and groups. The Service is provided for entertainment purposes only.</p>

          <h2>4. User Accounts</h2>
          <p>To use certain features of the Service, you must create an account. You are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Providing accurate and complete information when creating your account</li>
            <li>Notifying us immediately of any unauthorized use of your account</li>
          </ul>

          <h2>5. Acceptable Use</h2>
          <p>You agree not to use the Service to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe upon the rights of others</li>
            <li>Post content that is harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable</li>
            <li>Post hate speech, sexually explicit content, or obscene material</li>
            <li>Post spam, scams, or fraudulent content</li>
            <li>Impersonate any person or entity</li>
            <li>Attempt to gain unauthorized access to the Service or other users' accounts</li>
            <li>Use the Service for commercial purposes without our written consent</li>
            <li>Interfere with or disrupt the Service or servers</li>
            <li>Use automated bots, scripts, or scraping tools</li>
            <li>Engage in any activity that could damage, disable, or impair the Service</li>
          </ul>

          <h2>6. User Content</h2>
          <p>You retain ownership of content you create and share on the Service. By posting content, you represent that you own or have the necessary rights to post such content.</p>
          <p>By posting content, you grant us a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content solely for the purpose of operating, improving, and promoting the Service.</p>
          <p>You retain all other rights to your content. You are solely responsible for the content you post and its accuracy. We reserve the right to remove content that violates these terms.</p>

          <h2>7. Third-Party Services</h2>
          <p>Our Service may contain links to third-party websites or services. We are not responsible for third-party websites, services, or content. Your use of third-party services is at your own risk and subject to their respective terms of service and privacy policies.</p>

          <h2>8. Copyright and DMCA</h2>
          <p>We respect intellectual property rights. If you believe that content on our Service infringes your copyright, please contact us at:</p>
          <p>Email: admin@sortafriends.com</p>
          <p>
            For clarity: titles, names, and short phrases are generally not protected by copyright. Mentioning or listing titles, names, or brand names in stacks (e.g., ranking movies, songs, public figures, or products) is allowed, provided you do not include copyrighted material (such as full lyrics, scripts, or copyrighted images) without permission and you respect trademark usage and our Community Rules.
          </p>
          <p>Your notice must include:</p>
          <ul>
            <li>Your contact information</li>
            <li>Description of the copyrighted work</li>
            <li>Description of where the material is located on our Service</li>
            <li>Statement of good faith belief that use is not authorized</li>
            <li>Statement that the information is accurate and you are authorized to act on behalf of the copyright owner</li>
          </ul>
          <p>If you believe your content was removed by mistake, you may submit a counter-notice to the same email address. Your counter-notice must include:</p>
          <ul>
            <li>Your contact information</li>
            <li>Identification of the removed content and its location</li>
            <li>Statement under penalty of perjury that you have a good faith belief the content was removed by mistake</li>
            <li>Consent to local federal court jurisdiction</li>
          </ul>

          <h2>9. Privacy</h2>
          <p>Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices.</p>

          <h2>10. Intellectual Property</h2>
          <p>The Service and its original content, features, and functionality are owned by us and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>

          <h2>11. Termination</h2>
          <p>We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including breach of these Terms of Service.</p>
          <p>We may also remove or suspend content at our discretion. Upon termination, your right to use the Service will cease immediately.</p>
          <p>You may request deletion of your account and associated data by contacting us. We will process such requests within 30 days. Certain contributions may remain available (e.g., group stacks) but will be dissociated from your account.</p>

          <h2>12. Disclaimers</h2>
          <p>The Service is provided "as is" and "as available" without warranties of any kind. We disclaim all warranties, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>

          <h2>13. Limitation of Liability</h2>
          <p>In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.</p>
          <p>Our total liability to you for any claims arising from your use of the Service shall not exceed the amount you have paid us in the past 12 months, or $100, whichever is greater.</p>

          <h2>14. Indemnification</h2>
          <p>You agree to defend, indemnify, and hold harmless us and our officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the Service, including but not limited to content you post.</p>

          <h2>15. Governing Law</h2>
          <p>These Terms of Service shall be governed by and construed in accordance with the laws of California, United States, without regard to its conflict of law provisions.</p>

          <h2>16. Dispute Resolution and Arbitration</h2>
          <p>Any dispute arising from these Terms of Service or your use of the Service shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. Arbitration will be conducted in California, United States.</p>
          <p>You agree to resolve disputes individually and waive any right to participate in a class action lawsuit or class-wide arbitration. You and we agree that each may bring claims against the other only in your or our individual capacity, and not as a plaintiff or class member in any purported class or representative proceeding.</p>
          <p>This arbitration agreement does not preclude you from bringing issues to the attention of federal, state, or local agencies, which can, if the law allows, seek relief against us on your behalf.</p>

          <h2>17. Changes to Terms</h2>
          <p>We reserve the right to modify or replace these Terms of Service at any time. Changes will take effect immediately upon posting to the Service. For material changes, we will provide notice via email or in-app notification.</p>
          <p>Your continued use of the Service after changes are posted constitutes acceptance of the new terms.</p>

          <h2>18. Contact Information</h2>
          <p>If you have any questions about these Terms of Service, please contact us at:</p>
          <p>Email: admin@sortafriends.com</p>

          <div style={{ marginTop: '30px', textAlign: 'center' }}>
            <button
              onClick={handleBack}
              className="btn"
              style={{ backgroundColor: 'var(--color-primary)', color: 'white', border: 'none' }}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
